export default "__VITE_ASSET__CQ$bwoAb__"